import firebase from "firebase/compat/app";
import firebaseConfig from "./firebaseConfig";

import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import "firebase/compat/app-check";

if (import.meta.env.DEV)
  globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = import.meta.env.VUE_APP_APPCHECK_DEBUG_TOKEN;

const firebaseApp = firebase.initializeApp(firebaseConfig);

const appCheckKey = import.meta.env.VUE_APP_APP_CHECK_PUBLIC_KEY;
if (appCheckKey)
  try {
    firebase.appCheck().activate(
      new firebase.appCheck.ReCaptchaEnterpriseProvider(appCheckKey),
      true,
    );
  } catch (e) {
    console.error("Firebase App Check init failed:", e);
  }
else if (import.meta.env.DEV)
  console.warn("Firebase App Check skipped: missing VUE_APP_APP_CHECK_PUBLIC_KEY");

export default firebaseApp.firestore();
